import styled from "@emotion/styled"
import { Desktop, NewText } from "ui"
import { extractProperty } from "utils"

const StyledEmbed = styled.iframe`
  height: 100%;
  width: 100%;
`
const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 189px;
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: center;

  ${(props) => props.theme.breakpoints.up("md")} {
    height: 510px;
    margin-top: 54px;
    margin-bottom: 60px;
  }

  ${(props) => props.theme.breakpoints.up("xl")} {
    height: 830.29px;
    margin-top: 68px;
    margin-bottom: 80px;
  }
`
const Padding = styled.div`
  padding: 0 28px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 220px;
  }
`
// This extracts the YouTube video ID from a YouTube URL.
const extractVideoId = (url: string) => {
  const regex =
    /(?:youtu.be\/|youtube.com\/(?:watch\?.*v=|embed\/|v\/))([a-zA-Z0-9_-]{11})/
  const match = url.match(regex)
  return match ? match[1] : null
}

type Props = {
  data: any
}

function Video({ data }: Props) {
  const videoId =
    extractVideoId(extractProperty(data, "youTubeLink")?.[0]?.url) || ""
  const text = extractProperty(data, "textUnderneathVideo")
  if (!videoId) {
    return null
  }

  const embedUrl = `https://www.youtube.com/embed/${videoId}`

  return (
    <Padding>
      <StyledContainer>
        <StyledEmbed src={embedUrl} />
        <Desktop>
          <NewText
            component="div"
            desktopFontSize={14}
            desktopLineHeight="20px"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </Desktop>
      </StyledContainer>
    </Padding>
  )
}

export default Video
